require('./bootstrap');
require('./components/datatables.min');
require('./components/dataTables.bootstrap4.min');
require('./components/main');
require('./components/info');
require('./components/other');
require('./components/swal')
require('./components/custom')
require('./components/select2')

// require('./components/notification');
require('./components/admin');


